/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiview_Source_GroupsInputs */



/**
* | output |
* | --- |
* | "Source Event Groups" |
*
* @param {Multiview_Source_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview_source_groups = /** @type {((inputs?: Multiview_Source_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiview_Source_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes d'événements sources")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellereignisgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi di eventi di origine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы исходных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos de eventos de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत घटना समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupos de eventos de origem")
	return /** @type {LocalizedString} */ ("Source Event Groups")
});